export default __webpack_public_path__ + "static/media/Automation_CoE.66435252.svg";